<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card header="Detalhes">
          <b-col sm="12">
              <b-row>
                <b-col sm="12">
                  <Callout variant="info">
                    <small class="text-muted">Pagamentos Efetuados Hoje</small><br>
                    <strong class="h4">Notas: </strong>
                    <strong class="h4 text-info"> {{contaTitulos}}</strong>
                    <strong class="h4"> Valor:</strong>
                    <strong class="h4 text-success"> {{somaTitulos}}</strong>
                    <b-button type="button"  variant="info" class="float-right" @click="$router.go(-1)" ><i class="fa fa-arrow-left"></i></b-button>
                    <b-button v-if="tabela.dados.length"  @click="imprimir()" type="button"  variant="warning" class="float-right"><i class="fa fa-print"></i></b-button>
                  </Callout>
                </b-col>
                
              </b-row>
              <hr class="mt-0">
          </b-col>
          <b-table  ref="tabela" 
                   class="mb-0 table-outline"
                   responsive="sm" :small="true" hover :items="tabela.dados" :fields="tabela.campos" head-variant="light">
            <template #cell(TIPO_BAIXA)="item">
              <b-badge pill :variant="colorirTipo(item.item.TIPO_BAIXA)">{{item.item.TIPO_BAIXA}}</b-badge>
            </template>      
          </b-table>
          
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Callout } from '../../components/'
import VueButtonSpinner from '../../components/VueButtonSpinner.vue'
import moment from 'moment'

export default {
  name: 'dashboard',
  components: {
    Callout,
    VueButtonSpinner
  },
  data: function () {
    return {
      isLoading: false,
      status: '',
      submmited: false,
      contaTitulos: 0,
      somaTitulos: 0.00,
      tabela: {
        dados: [],
        campos: [
          {
            key: "DOCUMENTO",
            label: 'Documento'
          },
          {
            key: "PARCELAS",
            label: 'Parc.'
          },
          {
            key: "DT_DOC",
            label: 'Data Doc.', 
            sortable: true,
            formatter: (value, key, item) => 
              moment(String(value)).format('DD/MM/YYYY')
          },
          {
            key: "NOME_CLIENTE",
            sortable: true,
            label: 'Fornecedor'
          },
          {
            key: "ITENS",
            label: 'Itens.'
          },
          {
            key: "TIPO_BAIXA",
            sortable: true,
            label: 'Tipo'
          },
          {
            key: 'VL_PAGO',
            class:'text-right', 
            label: 'Pago (R$)', 
            sortable: true,
            formatter: (value, key, item) => 
              value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : null
          }
          
        ]
    
      }
    }
  },
  methods: {
    colorirTipo(valor) {
      if (valor == 'PARCIAL') return 'warning'
      else return 'success'
    },
    numberToReal (numero) {
      if (!numero) {
        return 'R$ 0,00'
      }
      let n = numero.toFixed(2).split('.')
      n[0] = 'R$ ' + n[0].split(/(?=(?:...)*$)/).join('.')
      return n.join(',')
    },
    carregarTabela () {
      this.$store.commit('controle/setAguardando', true)
      this.contaTitulos = 0,
      this.somaTitulos = 0.00
      let uri = this.$http.defaults.baseURL.concat('api/protected/pago/listarpagoHoje')
      this.tabela.dados = []
      let promise = this.$http.get(uri)
      promise.then((data) => {
        if (data) {
          let soma = 0.00
          this.tabela.dados = data.data
          this.contaTitulos = this.tabela.dados.length

          for (let i = 0; i < this.tabela.dados.length; i++) {
             soma += this.tabela.dados[i].VL_PAGO
          }
          
          this.somaTitulos = soma ? soma.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : null

          this.$store.commit('controle/setAguardando', false)
          return true
        } else {
          this.$store.commit('controle/setAguardando', false)
          return false
        }
        
      })
      .catch((err) =>{
        this.$store.commit('controle/setAguardando', false)
         this.$root.$bvToast.toast(`Não foi possível localizar os dados!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'danger',
            appendToast: true
          })
      })
    },
    imprimir () {
      
      let uri = '/api/protected/relatorios/pago/relpago?dt1=' +moment(new Date()).format('MM/DD/YYYY') +
          '&dt2='  +moment(new Date()).format('MM/DD/YYYY')   +
          '&lbusuario=' + window.localStorage.getItem('nomeusuario') +
          '&lbempresa=' + window.localStorage.getItem('nomeempresa') +
          '&tiporel=S'
      this.$store.commit('controle/setAguardando', true)
      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.$store.commit('controle/setAguardando', false)
          this.$root.$bvToast.toast(`Relatório Gerado com sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'success',
            appendToast: true
          })
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'relPagoHoje.pdf')
          link.download = 'relPagoHoje.pdf'
          // document.body.appendChild(link)
          //link.click()
          // document.body.removeChild(link)
          const janela = window.open(link)
          /*
          setTimeout(() =>
            { 
                janela.document.title = 'Relatório de Vendas'; 
            }, 1000);
            */
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = 'Relatório de Pagamentos do Dia'
            }, 2000);
          }
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          this.$toast.error({
            title: 'Erro',
            message: 'Ocorreram erros ao gerar o Relatorio ',
            progressBar: false,
            showMethod: 'shake',
            position: 'top full width'
          })
          
        })
    }
  },
  created () {
    this.carregarTabela()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/PagoHoje.vue